import { iconStyle } from 'shared/consts'
import { IonIcon } from '@ionic/react'
import  { browsersOutline, desktopOutline, listOutline, peopleOutline, pulseOutline, funnelOutline, gridOutline, 
    homeOutline, keyOutline, personCircleOutline, statsChartOutline, settingsOutline, trendingUp, tvOutline, 
    bookOutline} from 'ionicons/icons'

const MenuIcons = {
    bookOutline: {
        active: <IonIcon icon={bookOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={bookOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    browsersOutline: {
        active: <IonIcon icon={browsersOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={browsersOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    desktopOutline: {
        active: <IonIcon icon={desktopOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={desktopOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    gridOutline: {
        active: <IonIcon icon={gridOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={gridOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    homeOutline: {
        active: <IonIcon icon={homeOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={homeOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    keyOutline: {
        active: <IonIcon icon={keyOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={keyOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    listOutline: {
        active: <IonIcon icon={listOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={listOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    personCircleOutline: {
        active: <IonIcon icon={personCircleOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={personCircleOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    peopleOutline: {
        active: <IonIcon icon={peopleOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={peopleOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    pulseOutline: {
        active: <IonIcon icon={pulseOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={pulseOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    settingsOutline: {
        active: <IonIcon icon={settingsOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={settingsOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    statsChartOutline: {
        active: <IonIcon icon={statsChartOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={statsChartOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    trendingUp: {
        active: <IonIcon icon={trendingUp} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={trendingUp} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    funnelOutline: {
        active: <IonIcon icon={funnelOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={funnelOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    tvOutline: {
        active: <IonIcon icon={tvOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={tvOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />
    }
}

export default MenuIcons